/**
 * Enums
 */
export enum AssetType {
  Video = "Video",
  Image = "Image",
  Audio = "Audio",
  Document = "Document",
}

export enum ProcessingStatus {
  Pending = "Pending",
  Processing = "Processing",
  Complete = "Complete",
  Failed = "Failed",
}

/** Stored-file categories that count toward an account's storage */
export type TStorageCategory = "documents" | "assets" | "editReviews" | "contracts";

/**
 * Where an account's storage goes, from the timeout monitor's daily count of the bucket: bytes per
 * category, and per project
 */
export type TStorageBreakdown = {
  byCategory: Record<TStorageCategory, number>;
  byProject: Record<string, number>;
};
